import { UAParser } from "ua-parser-js";
import { sha256 } from 'js-sha256';
import type { PageViewPayload } from "@/services/view";
import type { PageType } from "#shared/types";
import { parseValue } from "#shared/utils/session";
import { Facebook, Tiktok } from "./integrations";

export function getUserAgent(pageType?: PageType): PageViewPayload {
  const ua = new UAParser().getResult();
  return {
    pageType: pageType as PageType || '',
    platform: ua.device.type || 'desktop',
    browser: ua.browser.name || '',
    browserVersion: ua.browser.version || '',
    osName: ua.os.name || '',
    osVersion: ua.os.version || '',
    deviceModel: ua.device.model || '',
    deviceVendor: ua.device.vendor || ''
  };
}

export function getSessionCookiesOnClient() {
  return Object.values(COOKIE).reduce((acc, cookie) => {
    acc[cookie] = parseValue(getClientCookie(cookie) || '');
    return acc;
  }, {} as Record<COOKIE, string | boolean | number | any[]>);
}

export function triggerRouteChange(routeName: string) {
  if (import.meta.client) {
    window.parent.postMessage({ route: routeName }, '*');
  }
}

export function getUserDataForIntegration(payload: {
  registerType: string;
  subscriberId?: string;
  countryCode?: string;
}) {
  const { registerType, subscriberId, countryCode } = payload || {};
  const hashedSubscriberId = subscriberId ? sha256(subscriberId) : undefined;
  const isEmail = subscriberId && (''+subscriberId.includes('@') || ''+subscriberId.includes('@privaterelay.appleid.com'));
  const registerFinalType = registerType === 'other'
    ? isEmail ? 'email' : undefined
    : registerType;

  const userData: Record<string, any> = {
    ...(registerFinalType ? {[registerFinalType === 'email' ? 'em' : 'ph']: hashedSubscriberId} : {}),
    country: countryCode,
    client_user_agent: globalThis?.navigator.userAgent
  }

  const context = {
    ...(registerFinalType ? {
      user: {
        [registerFinalType === 'email' ? 'email' : 'phone_number']: hashedSubscriberId
      }
    } : {}),
    user_agent: globalThis?.navigator.userAgent
  }

  return {
    user_data: userData,
    context
  }
}

export function eventRegisterSuccess(payload?: {
  registerType: string;
  subscriberId?: string;
  countryCode?: string;
}) {
  const { user_data: userData, context } = getUserDataForIntegration(payload!);

  Facebook.track('CompleteRegistration', {
    pageType: 'Registration',
    pageSlug: globalThis?.location?.pathname,
    user_data: userData
  });

  Tiktok.track('CompleteRegistration', {
    pageType: 'Registration',
    pageSlug: globalThis?.location?.pathname,
    context
  });
}
